var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCheckPerformance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 5,
    fill: "#315CD5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_347_197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 8.63516C10.5609 8.63516 7.44216 10.5167 5.14084 13.5729C4.95305 13.8233 4.95305 14.1731 5.14084 14.4234C7.44216 17.4833 10.5609 19.3648 14 19.3648C17.4391 19.3648 20.5578 17.4833 22.8592 14.4271C23.0469 14.1767 23.0469 13.8269 22.8592 13.5766C20.5578 10.5167 17.4391 8.63516 14 8.63516ZM14.2467 17.7778C11.9638 17.9214 10.0786 16.0399 10.2222 13.7533C10.34 11.8681 11.8681 10.34 13.7533 10.2222C16.0362 10.0785 17.9214 11.9601 17.7778 14.2467C17.6563 16.1283 16.1283 17.6563 14.2467 17.7778ZM14.1326 16.0325C12.9027 16.1098 11.8865 15.0973 11.9675 13.8674C12.0301 12.8512 12.8549 12.0301 13.8711 11.9638C15.101 11.8865 16.1172 12.899 16.0362 14.1289C15.9699 15.1488 15.1451 15.9699 14.1326 16.0325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_347_197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPerformance);
export default __webpack_public_path__ + "static/media/checkPerformance.261ca8dac95081e844a899259ba53fd8.svg";
export { ForwardRef as ReactComponent };